













































import Vue, { PropType } from 'vue';
import { BCol, BRow, BButton } from 'bootstrap-vue';
import { Element } from '../types';

export default Vue.extend({
  name: 'Elements',
  components: {
    BCol,
    BRow,
    BButton,
  },
  props: {
    elements: {
      type: Object as PropType<{ factors: Element[]; vectors: Element[]; scores: Element[] }>,
      default: () => {},
    },
  },
  computed: {
    numberOfCols() {
      return this.elements.scores.length ? 4 : 6;
    },
  },
});
